/**
 * Mini Calendar Widget Container
 *
 * App-layer container that connects the presentational
 * {@link MiniCalendarWidget} to the family-calendar store.
 *
 * @module app/widgets/MiniCalendarWidgetContainer
 */

import { useCalendarStore } from '@/features/family-calendar/stores/calendarStore';
import { MiniCalendarWidget } from '@/shared/components/widgets/MiniCalendarWidget';

interface MiniCalendarWidgetContainerProps {
  readonly size?: 'sm' | 'md';
  readonly className?: string;
  readonly showHeader?: boolean;
  readonly initialDate?: Date;
}

export function MiniCalendarWidgetContainer(
  props: MiniCalendarWidgetContainerProps
) {
  const events = useCalendarStore((state) => state.events);
  return <MiniCalendarWidget {...props} events={events} />;
}
